export const actions = {
  BIBAVATARES_LOAD_REQUESTED: 'BIBAVATARES_LOAD_REQUESTED',
  BIBAVATARES_LOAD_SUCCEEDED: 'BIBAVATARES_LOAD_SUCCEEDED',
  BIBAVATARES_LOAD_FAILED: 'BIBAVATARES_LOAD_FAILED',

  BIBAVATARES_BYID_LOAD_REQUESTED: 'BIBAVATARES_BYID_LOAD_REQUESTED',
  BIBAVATARES_BYID_LOAD_SUCCEEDED: 'BIBAVATARES_BYID_LOAD_SUCCEEDED',
  BIBAVATARES_BYID_LOAD_FAILED: 'BIBAVATARES_BYID_LOAD_FAILED',

  BIBAVATARES_INSERT_REQUESTED: 'BIBAVATARES_INSERT_REQUESTED',
  BIBAVATARES_INSERT_SUCCEEDED: 'BIBAVATARES_INSERT_SUCCEEDED',
  BIBAVATARES_INSERT_FAILED: 'BIBAVATARES_INSERT_FAILED',

  BIBAVATARES_UPDATE_REQUESTED: 'BIBAVATARES_UPDATE_REQUESTED',
  BIBAVATARES_UPDATE_SUCCEEDED: 'BIBAVATARES_UPDATE_SUCCEEDED',
  BIBAVATARES_UPDATE_FAILED: 'BIBAVATARES_UPDATE_FAILED',

  DELETE_BIBAVATARES_REQUESTED: 'DELETE_BIBAVATARES_REQUESTED',
  DELETE_BIBAVATARES_SUCCEEDED: 'DELETE_BIBAVATARES_SUCCEEDED',
  DELETE_BIBAVATARES_FAILED: 'DELETE_BIBAVATARES_FAILED',

  BIBAVATARES_FAM_UPDATE_ORDER_REQUESTED: 'BIBAVATARES_FAM_UPDATE_ORDER_REQUESTED',
  BIBAVATARES_FAM_UPDATE_ORDER_SUCCEEDED: 'BIBAVATARES_FAM_UPDATE_ORDER_SUCCEEDED',
  BIBAVATARES_FAM_UPDATE_ORDER_FAILED: 'BIBAVATARES_FAM_UPDATE_ORDER_FAILED',

  BIBAVATARES_PALETA_LOAD_REQUESTED: 'BIBAVATARES_PALETA_LOAD_REQUESTED',
  BIBAVATARES_PALETA_LOAD_SUCCEEDED: 'BIBAVATARES_PALETA_LOAD_SUCCEEDED',
  BIBAVATARES_PALETA_LOAD_FAILED: 'BIBAVATARES_PALETA_LOAD_FAILED',

  BIBAVATARES_PALETA_BYID_LOAD_REQUESTED: 'BIBAVATARES_PALETA_BYID_LOAD_REQUESTED',
  BIBAVATARES_PALETA_BYID_LOAD_SUCCEEDED: 'BIBAVATARES_PALETA_BYID_LOAD_SUCCEEDED',
  BIBAVATARES_PALETA_BYID_LOAD_FAILED: 'BIBAVATARES_PALETA_BYID_LOAD_FAILED',

  BIBAVATARES_PALETA_INSERT_REQUESTED: 'BIBAVATARES_PALETA_INSERT_REQUESTED',
  BIBAVATARES_PALETA_INSERT_SUCCEEDED: 'BIBAVATARES_PALETA_INSERT_SUCCEEDED',
  BIBAVATARES_PALETA_INSERT_FAILED: 'BIBAVATARES_PALETA_INSERT_FAILED',

  BIBAVATARES_PALETA_UPDATE_REQUESTED: 'BIBAVATARES_PALETA_UPDATE_REQUESTED',
  BIBAVATARES_PALETA_UPDATE_SUCCEEDED: 'BIBAVATARES_PALETA_UPDATE_SUCCEEDED',
  BIBAVATARES_PALETA_UPDATE_FAILED: 'BIBAVATARES_PALETA_UPDATE_FAILED',

  BIBAVATARES_PALETA_DUPLICAR_REQUESTED: 'BIBAVATARES_PALETA_DUPLICAR_REQUESTED',
  BIBAVATARES_PALETA_DUPLICAR_SUCCEEDED: 'BIBAVATARES_PALETA_DUPLICAR_SUCCEEDED',
  BIBAVATARES_PALETA_DUPLICAR_FAILED: 'BIBAVATARES_PALETA_DUPLICAR_FAILED',

  DELETE_BIBAVATARES_PALETA_REQUESTED: 'DELETE_BIBAVATARES_PALETA_REQUESTED',
  DELETE_BIBAVATARES_PALETA_SUCCEEDED: 'DELETE_BIBAVATARES_PALETA_SUCCEEDED',
  DELETE_BIBAVATARES_PALETA_FAILED: 'DELETE_BIBAVATARES_PALETA_FAILED',

  BIBAVATARES_SECCION_LOAD_REQUESTED: 'BIBAVATARES_SECCION_LOAD_REQUESTED',
  BIBAVATARES_SECCION_LOAD_SUCCEEDED: 'BIBAVATARES_SECCION_LOAD_SUCCEEDED',
  BIBAVATARES_SECCION_LOAD_FAILED: 'BIBAVATARES_SECCION_LOAD_FAILED',

  BIBAVATARES_SECCION_BYID_LOAD_REQUESTED: 'BIBAVATARES_SECCION_BYID_LOAD_REQUESTED',
  BIBAVATARES_SECCION_BYID_LOAD_SUCCEEDED: 'BIBAVATARES_SECCION_BYID_LOAD_SUCCEEDED',
  BIBAVATARES_SECCION_BYID_LOAD_FAILED: 'BIBAVATARES_SECCION_BYID_LOAD_FAILED',

  BIBAVATARES_SECCION_INSERT_REQUESTED: 'BIBAVATARES_SECCION_INSERT_REQUESTED',
  BIBAVATARES_SECCION_INSERT_SUCCEEDED: 'BIBAVATARES_SECCION_INSERT_SUCCEEDED',
  BIBAVATARES_SECCION_INSERT_FAILED: 'BIBAVATARES_SECCION_INSERT_FAILED',

  BIBAVATARES_SECCION_UPDATE_REQUESTED: 'BIBAVATARES_SECCION_UPDATE_REQUESTED',
  BIBAVATARES_SECCION_UPDATE_SUCCEEDED: 'BIBAVATARES_SECCION_UPDATE_SUCCEEDED',
  BIBAVATARES_SECCION_UPDATE_FAILED: 'BIBAVATARES_SECCION_UPDATE_FAILED',

  BIBAVATARES_SECCION_UPDATE_ORDER_REQUESTED: 'BIBAVATARES_SECCION_UPDATE_ORDER_REQUESTED',
  BIBAVATARES_SECCION_UPDATE_ORDER_SUCCEEDED: 'BIBAVATARES_SECCION_UPDATE_ORDER_SUCCEEDED',
  BIBAVATARES_SECCION_UPDATE_ORDER_FAILED: 'BIBAVATARES_SECCION_UPDATE_ORDER_FAILED',

  DELETE_BIBAVATARES_SECCION_REQUESTED: 'DELETE_BIBAVATARES_SECCION_REQUESTED',
  DELETE_BIBAVATARES_SECCION_SUCCEEDED: 'DELETE_BIBAVATARES_SECCION_SUCCEEDED',
  DELETE_BIBAVATARES_SECCION_FAILED: 'DELETE_BIBAVATARES_SECCION_FAILED',

  BIBAVATARES_SIZE_LOAD_REQUESTED: 'BIBAVATARES_SIZE_LOAD_REQUESTED',
  BIBAVATARES_SIZEFAM_LOAD_REQUESTED: 'BIBAVATARES_SIZEFAM_LOAD_REQUESTED',
  BIBAVATARES_SIZE_LOAD_SUCCEEDED: 'BIBAVATARES_SIZE_LOAD_SUCCEEDED',
  BIBAVATARES_SIZE_LOAD_FAILED: 'BIBAVATARES_SIZE_LOAD_FAILED',

  BIBAVATARES_SIZE_BYID_LOAD_REQUESTED: 'BIBAVATARES_SIZE_BYID_LOAD_REQUESTED',
  BIBAVATARES_SIZE_BYID_LOAD_SUCCEEDED: 'BIBAVATARES_SIZE_BYID_LOAD_SUCCEEDED',
  BIBAVATARES_SIZE_BYID_LOAD_FAILED: 'BIBAVATARES_SIZE_BYID_LOAD_FAILED',

  BIBAVATARES_SIZE_INSERT_REQUESTED: 'BIBAVATARES_SIZE_INSERT_REQUESTED',
  BIBAVATARES_SIZE_INSERT_SUCCEEDED: 'BIBAVATARES_SIZE_INSERT_SUCCEEDED',
  BIBAVATARES_SIZE_INSERT_FAILED: 'BIBAVATARES_SIZE_INSERT_FAILED',

  BIBAVATARES_SIZE_UPDATE_REQUESTED: 'BIBAVATARES_SIZE_UPDATE_REQUESTED',
  BIBAVATARES_SIZE_UPDATE_SUCCEEDED: 'BIBAVATARES_SIZE_UPDATE_SUCCEEDED',
  BIBAVATARES_SIZE_UPDATE_FAILED: 'BIBAVATARES_SIZE_UPDATE_FAILED',

  DELETE_BIBAVATARES_SIZE_REQUESTED: 'DELETE_BIBAVATARES_SIZE_REQUESTED',
  DELETE_BIBAVATARES_SIZE_SUCCEEDED: 'DELETE_BIBAVATARES_SIZE_SUCCEEDED',
  DELETE_BIBAVATARES_SIZE_FAILED: 'DELETE_BIBAVATARES_SIZE_FAILED',

  BIBAVATARES_CLIENTE_RESUME_LOAD_REQUESTED: 'BIBAVATARES_CLIENTE_RESUME_LOAD_REQUESTED',
  BIBAVATARES_CLIENTE_RESUME_LOAD_SUCCEEDED: 'BIBAVATARES_CLIENTE_RESUME_LOAD_SUCCEEDED',
  BIBAVATARES_CLIENTE_RESUME_LOAD_FAILED: 'BIBAVATARES_CLIENTE_RESUME_LOAD_FAILED',

  BIBAVATARES_CLIENTE_ADMIN_LOAD_REQUESTED: 'BIBAVATARES_CLIENTE_ADMIN_LOAD_REQUESTED',
  BIBAVATARES_CLIENTE_ADMIN_LOAD_SUCCEEDED: 'BIBAVATARES_CLIENTE_ADMIN_LOAD_SUCCEEDED',
  BIBAVATARES_CLIENTE_ADMIN_LOAD_FAILED: 'BIBAVATARES_CLIENTE_ADMIN_LOAD_FAILED',

  BIBAVATARES_CLIENTE_EMAIL_ADMIN_LOAD_REQUESTED: 'BIBAVATARES_CLIENTE_EMAIL_ADMIN_LOAD_REQUESTED',
  BIBAVATARES_CLIENTE_EMAIL_ADMIN_LOAD_SUCCEEDED: 'BIBAVATARES_CLIENTE_EMAIL_ADMIN_LOAD_SUCCEEDED',
  BIBAVATARES_CLIENTE_EMAIL_ADMIN_LOAD_FAILED: 'BIBAVATARES_CLIENTE_EMAIL_ADMIN_LOAD_FAILED',

  BIBAVATARES_GALERIA_LOAD_REQUESTED: 'BIBAVATARES_GALERIA_LOAD_REQUESTED',
  BIBAVATARES_GALERIA_LOAD_SUCCEEDED: 'BIBAVATARES_GALERIA_LOAD_SUCCEEDED',
  BIBAVATARES_GALERIA_LOAD_FAILED: 'BIBAVATARES_GALERIA_LOAD_FAILED',

  BIBAVATARES_OBJETO_BYID_LOAD_REQUESTED: 'BIBAVATARES_OBJETO_BYID_LOAD_REQUESTED',
  BIBAVATARES_OBJETO_BYID_LOAD_SUCCEEDED: 'BIBAVATARES_OBJETO_BYID_LOAD_SUCCEEDED',
  BIBAVATARES_OBJETO_BYID_LOAD_FAILED: 'BIBAVATARES_OBJETO_BYID_LOAD_FAILED',

  BIBAVATARES_MODELO_BYID_LOAD_REQUESTED: 'BIBAVATARES_MODELO_BYID_LOAD_REQUESTED',
  BIBAVATARES_MODELO_BYID_LOAD_SUCCEEDED: 'BIBAVATARES_MODELO_BYID_LOAD_SUCCEEDED',
  BIBAVATARES_MODELO_BYID_LOAD_FAILED: 'BIBAVATARES_MODELO_BYID_LOAD_FAILED',

  BIBAVATARES_OBJETO_INSERT_REQUESTED: 'BIBAVATARES_OBJETO_INSERT_REQUESTED',
  BIBAVATARES_OBJETO_INSERT_SUCCEEDED: 'BIBAVATARES_OBJETO_INSERT_SUCCEEDED',
  BIBAVATARES_OBJETO_INSERT_FAILED: 'BIBAVATARES_OBJETO_INSERT_FAILED',

  BIBAVATARES_OBJETO_UPDATE_REQUESTED: 'BIBAVATARES_OBJETO_UPDATE_REQUESTED',
  BIBAVATARES_OBJETO_UPDATE_SUCCEEDED: 'BIBAVATARES_OBJETO_UPDATE_SUCCEEDED',
  BIBAVATARES_OBJETO_UPDATE_FAILED: 'BIBAVATARES_OBJETO_UPDATE_FAILED',

  DELETE_BIBAVATARES_OBJETO_REQUESTED: 'DELETE_BIBAVATARES_OBJETO_REQUESTED',
  DELETE_BIBAVATARES_OBJETO_SUCCEEDED: 'DELETE_BIBAVATARES_OBJETO_SUCCEEDED',
  DELETE_BIBAVATARES_OBJETO_FAILED: 'DELETE_BIBAVATARES_OBJETO_FAILED',

  BIBAVATARES_OBJETO_UNICO_BYID_LOAD_REQUESTED: 'BIBAVATARES_OBJETO_UNICO_BYID_LOAD_REQUESTED',
  BIBAVATARES_OBJETO_UNICO_BYID_LOAD_SUCCEEDED: 'BIBAVATARES_OBJETO_UNICO_BYID_LOAD_SUCCEEDED',
  BIBAVATARES_OBJETO_UNICO_BYID_LOAD_FAILED: 'BIBAVATARES_OBJETO_UNICO_BYID_LOAD_FAILED',

  BIBAVATARES_OBJETO_UNICO_UPDATE_REQUESTED: 'BIBAVATARES_OBJETO_UNICO_UPDATE_REQUESTED',
  BIBAVATARES_OBJETO_UNICO_UPDATE_SUCCEEDED: 'BIBAVATARES_OBJETO_UNICO_UPDATE_SUCCEEDED',
  BIBAVATARES_OBJETO_UNICO_UPDATE_FAILED: 'BIBAVATARES_OBJETO_UNICO_UPDATE_FAILED',

  BIBAVATARES_OBJETO_VARIANTE_BYID_LOAD_REQUESTED:
    'BIBAVATARES_OBJETO_VARIANTE_BYID_LOAD_REQUESTED',
  BIBAVATARES_OBJETO_VARIANTE_BYID_LOAD_SUCCEEDED:
    'BIBAVATARES_OBJETO_VARIANTE_BYID_LOAD_SUCCEEDED',
  BIBAVATARES_OBJETO_VARIANTE_BYID_LOAD_FAILED: 'BIBAVATARES_OBJETO_VARIANTE_BYID_LOAD_FAILED',

  BIBAVATARES_OBJETO_VARIANTE_UPDATE_REQUESTED: 'BIBAVATARES_OBJETO_VARIANTE_UPDATE_REQUESTED',
  BIBAVATARES_OBJETO_VARIANTE_UPDATE_SUCCEEDED: 'BIBAVATARES_OBJETO_VARIANTE_UPDATE_SUCCEEDED',
  BIBAVATARES_OBJETO_VARIANTE_UPDATE_FAILED: 'BIBAVATARES_OBJETO_VARIANTE_UPDATE_FAILED',

  BIBAVATARES_OBJETO_VARIANTE_SIZE_REQUESTED: 'BIBAVATARES_OBJETO_VARIANTE_SIZE_REQUESTED',
  BIBAVATARES_OBJETO_VARIANTE_SIZE_SUCCEEDED: 'BIBAVATARES_OBJETO_VARIANTE_SIZE_SUCCEEDED',
  BIBAVATARES_OBJETO_VARIANTE_SIZE_FAILED: 'BIBAVATARES_OBJETO_VARIANTE_SIZE_FAILED',

  DELETE_BIBAVATARES_OBJETO_VARIANTE_REQUESTED: 'DELETE_BIBAVATARES_OBJETO_VARIANTE_REQUESTED',
  DELETE_BIBAVATARES_OBJETO_VARIANTE_SUCCEEDED: 'DELETE_BIBAVATARES_OBJETO_VARIANTE_SUCCEEDED',
  DELETE_BIBAVATARES_OBJETO_VARIANTE_FAILED: 'DELETE_BIBAVATARES_OBJETO_VARIANTE_FAILED',

  BIBAVATARES_CACHE_CLIENTE_UPDATE_REQUESTED: 'BIBAVATARES_CACHE_CLIENTE_UPDATE_REQUESTED',
  BIBAVATARES_CACHE_CLIENTE_UPDATE_SUCCEEDED: 'BIBAVATARES_CACHE_CLIENTE_UPDATE_SUCCEEDED',
  BIBAVATARES_CACHE_CLIENTE_UPDATE_FAILED: 'BIBAVATARES_CACHE_CLIENTE_UPDATE_FAILED',

  BIBAVATARES_CACHE_ADMIN_UPDATE_REQUESTED: 'BIBAVATARES_CACHE_ADMIN_UPDATE_REQUESTED',
  BIBAVATARES_CACHE_ADMIN_UPDATE_SUCCEEDED: 'BIBAVATARES_CACHE_ADMIN_UPDATE_SUCCEEDED',
  BIBAVATARES_CACHE_ADMIN_UPDATE_FAILED: 'BIBAVATARES_CACHE_ADMIN_UPDATE_FAILED',

  BIBAVATARES_CACHE_FAMILIAS_UPDATE_REQUESTED: 'BIBAVATARES_CACHE_FAMILIAS_UPDATE_REQUESTED',
  BIBAVATARES_CACHE_FAMILIAS_UPDATE_SUCCEEDED: 'BIBAVATARES_CACHE_FAMILIAS_UPDATE_SUCCEEDED',
  BIBAVATARES_CACHE_FAMILIAS_UPDATE_FAILED: 'BIBAVATARES_CACHE_FAMILIAS_UPDATE_FAILED',

  BIBAVATARES_CACHE_PRODUCTOS_UPDATE_REQUESTED: 'BIBAVATARES_CACHE_PRODUCTOS_UPDATE_REQUESTED',
  BIBAVATARES_CACHE_PRODUCTOS_UPDATE_SUCCEEDED: 'BIBAVATARES_CACHE_PRODUCTOS_UPDATE_SUCCEEDED',
  BIBAVATARES_CACHE_PRODUCTOS_UPDATE_FAILED: 'BIBAVATARES_CACHE_PRODUCTOS_UPDATE_FAILED',

  BIBAVATARES_CACHE_PAISES_UPDATE_REQUESTED: 'BIBAVATARES_CACHE_PAISES_UPDATE_REQUESTED',
  BIBAVATARES_CACHE_PAISES_UPDATE_SUCCEEDED: 'BIBAVATARES_CACHE_PAISES_UPDATE_SUCCEEDED',
  BIBAVATARES_CACHE_PAISES_UPDATE_FAILED: 'BIBAVATARES_CACHE_PAISES_UPDATE_FAILED',

  BIBAVATARES_CACHE_PROVINCIAS_UPDATE_REQUESTED: 'BIBAVATARES_CACHE_PROVINCIAS_UPDATE_REQUESTED',
  BIBAVATARES_CACHE_PROVINCIAS_UPDATE_SUCCEEDED: 'BIBAVATARES_CACHE_PROVINCIAS_UPDATE_SUCCEEDED',
  BIBAVATARES_CACHE_PROVINCIAS_UPDATE_FAILED: 'BIBAVATARES_CACHE_PROVINCIAS_UPDATE_FAILED',

  BIBAVATARES_GALERIA_MASIVO_REQUESTED: 'BIBAVATARES_GALERIA_MASIVO_REQUESTED',
  BIBAVATARES_GALERIA_MASIVO_SUCCEEDED: 'BIBAVATARES_GALERIA_MASIVO_SUCCEEDED',
  BIBAVATARES_GALERIA_MASIVO_FAILED: 'BIBAVATARES_GALERIA_MASIVO_FAILED',

  BIBAVATARES_GALERIA_CONFIRM_MASIVO_REQUESTED: 'BIBAVATARES_GALERIA_CONFIRM_MASIVO_REQUESTED',
  BIBAVATARES_GALERIA_CONFIRM_MASIVO_SUCCEEDED: 'BIBAVATARES_GALERIA_CONFIRM_MASIVO_SUCCEEDED',
  BIBAVATARES_GALERIA_CONFIRM_MASIVO_FAILED: 'BIBAVATARES_GALERIA_CONFIRM_MASIVO_FAILED',

  BIBAVATARES_GALERIA_UPLOAD_IMAGE_REQUESTED: 'BIBAVATARES_GALERIA_UPLOAD_IMAGE_REQUESTED',
  BIBAVATARES_GALERIA_UPLOAD_IMAGE_SUCCEEDED: 'BIBAVATARES_GALERIA_UPLOAD_IMAGE_SUCCEEDED',
  BIBAVATARES_GALERIA_UPLOAD_IMAGE_FAILED: 'BIBAVATARES_GALERIA_UPLOAD_IMAGE_FAILED',

  BIBAVATARES_PLANTILLA_LOAD_REQUESTED: 'BIBAVATARES_PLANTILLA_LOAD_REQUESTED',
  BIBAVATARES_PLANTILLA_LOAD_SUCCEEDED: 'BIBAVATARES_PLANTILLA_LOAD_SUCCEEDED',
  BIBAVATARES_PLANTILLA_LOAD_FAILED: 'BIBAVATARES_PLANTILLA_LOAD_FAILED',

  BIBAVATARES_PLANTILLA_BYID_LOAD_REQUESTED: 'BIBAVATARES_PLANTILLA_BYID_LOAD_REQUESTED',
  BIBAVATARES_PLANTILLA_BYID_LOAD_SUCCEEDED: 'BIBAVATARES_PLANTILLA_BYID_LOAD_SUCCEEDED',
  BIBAVATARES_PLANTILLA_BYID_LOAD_FAILED: 'BIBAVATARES_PLANTILLA_BYID_LOAD_FAILED',

  BIBAVATARES_PLANTILLA_INSERT_REQUESTED: 'BIBAVATARES_PLANTILLA_INSERT_REQUESTED',
  BIBAVATARES_PLANTILLA_INSERT_SUCCEEDED: 'BIBAVATARES_PLANTILLA_INSERT_SUCCEEDED',
  BIBAVATARES_PLANTILLA_INSERT_FAILED: 'BIBAVATARES_PLANTILLA_INSERT_FAILED',

  BIBAVATARES_PLANTILLA_UPDATE_REQUESTED: 'BIBAVATARES_PLANTILLA_UPDATE_REQUESTED',
  BIBAVATARES_PLANTILLA_UPDATE_SUCCEEDED: 'BIBAVATARES_PLANTILLA_UPDATE_SUCCEEDED',
  BIBAVATARES_PLANTILLA_UPDATE_FAILED: 'BIBAVATARES_PLANTILLA_UPDATE_FAILED',

  DELETE_BIBAVATARES_PLANTILLA_REQUESTED: 'DELETE_BIBAVATARES_PLANTILLA_REQUESTED',
  DELETE_BIBAVATARES_PLANTILLA_SUCCEEDED: 'DELETE_BIBAVATARES_PLANTILLA_SUCCEEDED',
  DELETE_BIBAVATARES_PLANTILLA_FAILED: 'DELETE_BIBAVATARES_PLANTILLA_FAILED',

  BIBAVATARES_PLANTILLA_OBJETOS_LOAD_REQUESTED: 'BIBAVATARES_PLANTILLA_OBJETOS_LOAD_REQUESTED',
  BIBAVATARES_PLANTILLA_OBJETOS_LOAD_SUCCEEDED: 'BIBAVATARES_PLANTILLA_OBJETOS_LOAD_SUCCEEDED',
  BIBAVATARES_PLANTILLA_OBJETOS_LOAD_FAILED: 'BIBAVATARES_PLANTILLA_OBJETOS_LOAD_FAILED',

  BIBAVATARES_PLANTILLA_OBJETO_BYID_LOAD_REQUESTED:
    'BIBAVATARES_PLANTILLA_OBJETO_BYID_LOAD_REQUESTED',
  BIBAVATARES_PLANTILLA_OBJETO_BYID_LOAD_SUCCEEDED:
    'BIBAVATARES_PLANTILLA_OBJETO_BYID_LOAD_SUCCEEDED',
  BIBAVATARES_PLANTILLA_OBJETO_BYID_LOAD_FAILED: 'BIBAVATARES_PLANTILLA_OBJETO_BYID_LOAD_FAILED',

  BIBAVATARES_LAYER_LOAD_REQUESTED: 'BIBAVATARES_LAYER_LOAD_REQUESTED',
  BIBAVATARES_LAYER_LOAD_SUCCEEDED: 'BIBAVATARES_LAYER_LOAD_SUCCEEDED',
  BIBAVATARES_LAYER_LOAD_FAILED: 'BIBAVATARES_LAYER_LOAD_FAILED',

  BIBAVATARES_LAYER_BYID_LOAD_REQUESTED: 'BIBAVATARES_LAYER_BYID_LOAD_REQUESTED',
  BIBAVATARES_LAYER_BYID_LOAD_SUCCEEDED: 'BIBAVATARES_LAYER_BYID_LOAD_SUCCEEDED',
  BIBAVATARES_LAYER_BYID_LOAD_FAILED: 'BIBAVATARES_LAYER_BYID_LOAD_FAILED',

  BIBAVATARES_LAYER_INSERT_REQUESTED: 'BIBAVATARES_LAYER_INSERT_REQUESTED',
  BIBAVATARES_LAYER_INSERT_SUCCEEDED: 'BIBAVATARES_LAYER_INSERT_SUCCEEDED',
  BIBAVATARES_LAYER_INSERT_FAILED: 'BIBAVATARES_LAYER_INSERT_FAILED',

  BIBAVATARES_LAYER_UPDATE_REQUESTED: 'BIBAVATARES_LAYER_UPDATE_REQUESTED',
  BIBAVATARES_LAYER_UPDATE_SUCCEEDED: 'BIBAVATARES_LAYER_UPDATE_SUCCEEDED',
  BIBAVATARES_LAYER_UPDATE_FAILED: 'BIBAVATARES_LAYER_UPDATE_FAILED',

  DELETE_BIBAVATARES_LAYER_REQUESTED: 'DELETE_BIBAVATARES_LAYER_REQUESTED',
  DELETE_BIBAVATARES_LAYER_SUCCEEDED: 'DELETE_BIBAVATARES_LAYER_SUCCEEDED',
  DELETE_BIBAVATARES_LAYER_FAILED: 'DELETE_BIBAVATARES_LAYER_FAILED',

  BIBAVATARES_COLOR_LOAD_REQUESTED: 'BIBAVATARES_COLOR_LOAD_REQUESTED',
  BIBAVATARES_COLOR_LOAD_SUCCEEDED: 'BIBAVATARES_COLOR_LOAD_SUCCEEDED',
  BIBAVATARES_COLOR_LOAD_FAILED: 'BIBAVATARES_COLOR_LOAD_FAILED',

  BIBAVATARES_COLOR_INSERT_REQUESTED: 'BIBAVATARES_COLOR_INSERT_REQUESTED',
  BIBAVATARES_COLOR_INSERT_SUCCEEDED: 'BIBAVATARES_COLOR_INSERT_SUCCEEDED',
  BIBAVATARES_COLOR_INSERT_FAILED: 'BIBAVATARES_COLOR_INSERT_FAILED',

  BIBAVATARES_COLOR_UPDATE_REQUESTED: 'BIBAVATARES_COLOR_UPDATE_REQUESTED',
  BIBAVATARES_COLOR_UPDATE_SUCCEEDED: 'BIBAVATARES_COLOR_UPDATE_SUCCEEDED',
  BIBAVATARES_COLOR_UPDATE_FAILED: 'BIBAVATARES_COLOR_UPDATE_FAILED',

  BIBAVATARES_COLOR_UPDATE_ORDER_REQUESTED: 'BIBAVATARES_COLOR_UPDATE_ORDER_REQUESTED',
  BIBAVATARES_COLOR_UPDATE_ORDER_SUCCEEDED: 'BIBAVATARES_COLOR_UPDATE_ORDER_SUCCEEDED',
  BIBAVATARES_COLOR_UPDATE_ORDER_FAILED: 'BIBAVATARES_COLOR_UPDATE_ORDER_FAILED',

  DELETE_BIBAVATARES_COLOR_REQUESTED: 'DELETE_BIBAVATARES_COLOR_REQUESTED',
  DELETE_BIBAVATARES_COLOR_SUCCEEDED: 'DELETE_BIBAVATARES_COLOR_SUCCEEDED',
  DELETE_BIBAVATARES_COLOR_FAILED: 'DELETE_BIBAVATARES_COLOR_FAILED',
  BIBAVATARES_PROD_BYID_LOAD_REQUESTED: 'BIBAVATARES_PROD_BYID_LOAD_REQUESTED',
  BIBAVATARES_PROD_BYID_LOAD_SUCCEEDED: 'BIBAVATARES_PROD_BYID_LOAD_SUCCEEDED',
  BIBAVATARES_PROD_BYID_LOAD_FAILED: 'BIBAVATARES_PROD_BYID_LOAD_FAILED',

  BIBAVATARES_PIEZA_LOAD_REQUESTED: 'BIBAVATARES_PIEZA_LOAD_REQUESTED',
  BIBAVATARES_PIEZA_LOAD_SUCCEEDED: 'BIBAVATARES_PIEZA_LOAD_SUCCEEDED',
  BIBAVATARES_PIEZA_LOAD_FAILED: 'BIBAVATARES_PIEZA_LOAD_FAILED',

  BIBAVATARES_PIEZA_BYID_LOAD_REQUESTED: 'BIBAVATARES_PIEZA_BYID_LOAD_REQUESTED',
  BIBAVATARES_PIEZA_BYID_LOAD_SUCCEEDED: 'BIBAVATARES_PIEZA_BYID_LOAD_SUCCEEDED',
  BIBAVATARES_PIEZA_BYID_LOAD_FAILED: 'BIBAVATARES_PIEZA_BYID_LOAD_FAILED',

  BIBAVATARES_PIEZA_INSERT_REQUESTED: 'BIBAVATARES_PIEZA_INSERT_REQUESTED',
  BIBAVATARES_PIEZA_INSERT_SUCCEEDED: 'BIBAVATARES_PIEZA_INSERT_SUCCEEDED',
  BIBAVATARES_PIEZA_INSERT_FAILED: 'BIBAVATARES_PIEZA_INSERT_FAILED',

  BIBAVATARES_PIEZA_UPDATE_REQUESTED: 'BIBAVATARES_PIEZA_UPDATE_REQUESTED',
  BIBAVATARES_PIEZA_UPDATE_SUCCEEDED: 'BIBAVATARES_PIEZA_UPDATE_SUCCEEDED',
  BIBAVATARES_PIEZA_UPDATE_FAILED: 'BIBAVATARES_PIEZA_UPDATE_FAILED',

  DELETE_BIBAVATARES_PIEZA_REQUESTED: 'DELETE_BIBAVATARES_PIEZA_REQUESTED',
  DELETE_BIBAVATARES_PIEZA_SUCCEEDED: 'DELETE_BIBAVATARES_PIEZA_SUCCEEDED',
  DELETE_BIBAVATARES_PIEZA_FAILED: 'DELETE_BIBAVATARES_PIEZA_FAILED',

  BIBAVATARES_OBJETO_INSERT_MINIATURA_REQUESTED: 'BIBAVATARES_OBJETO_INSERT_MINIATURA_REQUESTED',
  BIBAVATARES_OBJETO_INSERT_MINIATURA_SUCCEEDED: 'BIBAVATARES_OBJETO_INSERT_MINIATURA_SUCCEEDED',
  BIBAVATARES_OBJETO_INSERT_MINIATURA_FAILED: 'BIBAVATARES_OBJETO_INSERT_MINIATURA_FAILED',

  BIBAVATARES_OBJETO_DELETE_MINIATURA_REQUESTED: 'BIBAVATARES_OBJETO_DELETE_MINIATURA_REQUESTED',
  BIBAVATARES_OBJETO_DELETE_MINIATURA_SUCCEEDED: 'BIBAVATARES_OBJETO_DELETE_MINIATURA_SUCCEEDED',
  BIBAVATARES_OBJETO_DELETE_MINIATURA_FAILED: 'BIBAVATARES_OBJETO_DELETE_MINIATURA_FAILED',

  BIBAVATARES_OBJETO_INSERT_IMPRESION_REQUESTED: 'BIBAVATARES_OBJETO_INSERT_IMPRESION_REQUESTED',
  BIBAVATARES_OBJETO_INSERT_IMPRESION_SUCCEEDED: 'BIBAVATARES_OBJETO_INSERT_IMPRESION_SUCCEEDED',
  BIBAVATARES_OBJETO_INSERT_IMPRESION_FAILED: 'BIBAVATARES_OBJETO_INSERT_IMPRESION_FAILED',

  BIBAVATARES_OBJETO_DELETE_IMPRESION_REQUESTED: 'BIBAVATARES_OBJETO_DELETE_IMPRESION_REQUESTED',
  BIBAVATARES_OBJETO_DELETE_IMPRESION_SUCCEEDED: 'BIBAVATARES_OBJETO_DELETE_IMPRESION_SUCCEEDED',
  BIBAVATARES_OBJETO_DELETE_IMPRESION_FAILED: 'BIBAVATARES_OBJETO_DELETE_IMPRESION_FAILED',

  BIBAVATARES_OBJETO_INSERT_VARIANTE_REQUESTED: 'BIBAVATARES_OBJETO_INSERT_VARIANTE_REQUESTED',
  BIBAVATARES_OBJETO_INSERT_VARIANTE_SUCCEEDED: 'BIBAVATARES_OBJETO_INSERT_VARIANTE_SUCCEEDED',
  BIBAVATARES_OBJETO_INSERT_VARIANTE_FAILED: 'BIBAVATARES_OBJETO_INSERT_VARIANTE_FAILED',

  BIBAVATARES_OBJETO_DELETE_VARIANTE_REQUESTED: 'BIBAVATARES_OBJETO_DELETE_VARIANTE_REQUESTED',
  BIBAVATARES_OBJETO_DELETE_VARIANTE_SUCCEEDED: 'BIBAVATARES_OBJETO_DELETE_VARIANTE_SUCCEEDED',
  BIBAVATARES_OBJETO_DELETE_VARIANTE_FAILED: 'BIBAVATARES_OBJETO_DELETE_VARIANTE_FAILED',
}

// Biblioteca de avatares
export const getBibAvataresAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.BIBAVATARES_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.BIBAVATARES_LOAD_REQUESTED,
    })
  }
}

export const deleteBibAvataresAction = (dispatch, id) => {
  dispatch({
    type: actions.DELETE_BIBAVATARES_REQUESTED,
    payload: id,
  })
}

export const onSubmitInsertBibAvataresFormAction = (dispatch, formBibAvatares) => {
  dispatch({
    type: actions.BIBAVATARES_INSERT_REQUESTED,
    payload: formBibAvatares,
  })
}

export const onSubmitUpdateBibAvataresFormAction = (dispatch, formBibAvatares) => {
  dispatch({
    type: actions.BIBAVATARES_UPDATE_REQUESTED,
    payload: formBibAvatares,
  })
}

export const onSubmitUpdateBibAvataresFamOrdenAction = (dispatch, data) => {
  dispatch({
    type: actions.BIBAVATARES_FAM_UPDATE_ORDER_REQUESTED,
    payload: data,
  })
}

// Paletas
export const getBibAvataresPaletasAction = (dispatch, fam) => {
  dispatch({
    type: actions.BIBAVATARES_PALETA_LOAD_REQUESTED,
    payload: fam,
  })
}

export const getBibAvataresPaletaByIdAction = (dispatch, id) => {
  dispatch({
    type: actions.BIBAVATARES_PALETA_BYID_LOAD_REQUESTED,
    payload: id,
  })
}

export const deleteBibAvataresPaletaAction = (dispatch, id) => {
  dispatch({
    type: actions.DELETE_BIBAVATARES_PALETA_REQUESTED,
    payload: id,
  })
}

export const onSubmitInsertBibAvataresPaletaFormAction = (dispatch, formBibAvataresPaleta) => {
  dispatch({
    type: actions.BIBAVATARES_PALETA_INSERT_REQUESTED,
    payload: formBibAvataresPaleta,
  })
}

export const onSubmitUpdateBibAvataresPaletaFormAction = (dispatch, formBibAvataresPaleta) => {
  dispatch({
    type: actions.BIBAVATARES_PALETA_UPDATE_REQUESTED,
    payload: formBibAvataresPaleta,
  })
}

export const onSubmitDuplicarBibAvataresPaletaFormAction = (dispatch, formBibAvataresPaleta) => {
  dispatch({
    type: actions.BIBAVATARES_PALETA_DUPLICAR_REQUESTED,
    payload: formBibAvataresPaleta,
  })
}

// Modelo
export const getBibAvataresModeloAction = (dispatch, id) => {
  dispatch({
    type: actions.BIBAVATARES_MODELO_BYID_LOAD_REQUESTED,
    payload: id,
  })
}

// Secciones
export const getBibAvataresSeccionesAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.BIBAVATARES_SECCION_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.BIBAVATARES_SECCION_LOAD_REQUESTED,
    })
  }
}

export const deleteBibAvataresSeccionAction = (dispatch, id) => {
  dispatch({
    type: actions.DELETE_BIBAVATARES_SECCION_REQUESTED,
    payload: id,
  })
}

export const onSubmitInsertBibAvataresSeccionFormAction = (dispatch, formBibAvataresSeccion) => {
  dispatch({
    type: actions.BIBAVATARES_SECCION_INSERT_REQUESTED,
    payload: formBibAvataresSeccion,
  })
}

export const onSubmitUpdateBibAvataresSeccionFormAction = (dispatch, formBibAvataresSeccion) => {
  dispatch({
    type: actions.BIBAVATARES_SECCION_UPDATE_REQUESTED,
    payload: formBibAvataresSeccion,
  })
}

export const onSubmitUpdateBibAvataresOrdenAction = (dispatch, data) => {
  dispatch({
    type: actions.BIBAVATARES_SECCION_UPDATE_ORDER_REQUESTED,
    payload: data,
  })
}

// Tamaños

export const getBibAvataresSizeAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.BIBAVATARES_SIZE_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.BIBAVATARES_SIZE_LOAD_REQUESTED,
    })
  }
}

export const getBibAvataresSizeFamAction = dispatch => {
  dispatch({
    type: actions.BIBAVATARES_SIZEFAM_LOAD_REQUESTED,
  })
}

export const deleteBibAvataresSizeAction = (dispatch, id) => {
  dispatch({
    type: actions.DELETE_BIBAVATARES_SIZE_REQUESTED,
    payload: id,
  })
}

export const onSubmitInsertBibAvataresSizeFormAction = (dispatch, formBibAvataresSeccion) => {
  dispatch({
    type: actions.BIBAVATARES_SIZE_INSERT_REQUESTED,
    payload: formBibAvataresSeccion,
  })
}

export const onSubmitUpdateBibAvataresSizeFormAction = (dispatch, formBibAvataresSeccion) => {
  dispatch({
    type: actions.BIBAVATARES_SIZE_UPDATE_REQUESTED,
    payload: formBibAvataresSeccion,
  })
}

// Galeria de cliente
export const getBibAvataresClienteResumeAction = (dispatch, formBibAvataresClienteResume) => {
  dispatch({
    type: actions.BIBAVATARES_CLIENTE_RESUME_LOAD_REQUESTED,
    payload: formBibAvataresClienteResume,
  })
}

export const getBibAvataresClienteAdminAction = (dispatch, formBibAvataresClienteAdmin) => {
  dispatch({
    type: actions.BIBAVATARES_CLIENTE_ADMIN_LOAD_REQUESTED,
    payload: formBibAvataresClienteAdmin,
  })
}

export const getBibAvataresClienteEmailAdminAction = (dispatch, formBibAvataresClienteAdmin) => {  
  dispatch({
    type: actions.BIBAVATARES_CLIENTE_EMAIL_ADMIN_LOAD_REQUESTED,
    payload: formBibAvataresClienteAdmin,
  })
}



// Galeria de familia
// export const getBibAvataresGaleria = (dispatch, id) => {
//   dispatch({
//     type: actions.BIBAVATARES_GALERIA_LOAD_REQUESTED,
//     payload: id,
//   })
// }
export const getBibAvataresGaleria = (dispatch, data) => {
  dispatch({
    type: actions.BIBAVATARES_GALERIA_LOAD_REQUESTED,
    payload: data,
  })
}

// Galeria > Objeto
export const getBibAvataresObjetoAction = (dispatch, id) => {
  dispatch({
    type: actions.BIBAVATARES_OBJETO_BYID_LOAD_REQUESTED,
    payload: id,
  })
}

export const onSubmitUpdateBibAvataresObjetoFormAction = (dispatch, formBibAvataresObjeto) => {
  dispatch({
    type: actions.BIBAVATARES_OBJETO_UPDATE_REQUESTED,
    payload: formBibAvataresObjeto,
  })
}

export const deleteBibAvataresObjetoAction = (dispatch, id) => {
  dispatch({
    type: actions.DELETE_BIBAVATARES_OBJETO_REQUESTED,
    payload: id,
  })
}

export const onSubmitInsertMiniaturaObjFormAction = (dispatch, form) => {
  dispatch({
    type: actions.BIBAVATARES_OBJETO_INSERT_MINIATURA_REQUESTED,
    payload: form,
  })
}

export const onSubmitDeleteMiniaturaObjFormAction = (dispatch, form) => {
  dispatch({
    type: actions.BIBAVATARES_OBJETO_DELETE_MINIATURA_REQUESTED,
    payload: form,
  })
}

export const onSubmitInsertImpresionObjFormAction = (dispatch, form) => {
  dispatch({
    type: actions.BIBAVATARES_OBJETO_INSERT_IMPRESION_REQUESTED,
    payload: form,
  })
}

export const onSubmitDeleteImpresionObjFormAction = (dispatch, form) => {
  dispatch({
    type: actions.BIBAVATARES_OBJETO_DELETE_IMPRESION_REQUESTED,
    payload: form,
  })
}

export const onSubmitInsertVarianteObjFormAction = (dispatch, form) => {
  dispatch({
    type: actions.BIBAVATARES_OBJETO_INSERT_VARIANTE_REQUESTED,
    payload: form,
  })
}

export const onSubmitDeleteVarianteObjFormAction = (dispatch, form) => {
  dispatch({
    type: actions.BIBAVATARES_OBJETO_DELETE_VARIANTE_REQUESTED,
    payload: form,
  })
}

// Galeria > Objeto unico
export const getBibAvataresObjetoUnicoAction = (dispatch, id) => {
  dispatch({
    type: actions.BIBAVATARES_OBJETO_UNICO_BYID_LOAD_REQUESTED,
    payload: id,
  })
}

export const onSubmitUpdateBibAvataresUnicoFormAction = (dispatch, formBibAvataresUnico) => {
  dispatch({
    type: actions.BIBAVATARES_OBJETO_UNICO_UPDATE_REQUESTED,
    payload: formBibAvataresUnico,
  })
}

// Galeria > Objeto variante
export const getBibAvataresObjetoVarianteAction = (dispatch, id) => {
  dispatch({
    type: actions.BIBAVATARES_OBJETO_VARIANTE_BYID_LOAD_REQUESTED,
    payload: id,
  })
}

export const onSubmitUpdateBibAvataresVarianteFormAction = (dispatch, formBibAvataresVariante) => {
  dispatch({
    type: actions.BIBAVATARES_OBJETO_VARIANTE_UPDATE_REQUESTED,
    payload: formBibAvataresVariante,
  })
}

export const onSubmitUpdateBibAvataresVarianteSizeFormAction = (
  dispatch,
  formBibAvataresVariante,
) => {
  dispatch({
    type: actions.BIBAVATARES_OBJETO_VARIANTE_SIZE_REQUESTED,
    payload: formBibAvataresVariante,
  })
}

export const deleteBibAvataresObjetoVarianteAction = (dispatch, id) => {
  dispatch({
    type: actions.DELETE_BIBAVATARES_OBJETO_VARIANTE_REQUESTED,
    payload: id,
  })
}

// Galeria > Objeto
export const onSubmitUpdateBibAvataresCacheClienteAction = (dispatch, id) => {
  dispatch({
    type: actions.BIBAVATARES_CACHE_CLIENTE_UPDATE_REQUESTED,
    payload: id,
  })
}

export const onSubmitUpdateBibAvataresCacheAdminAction = (dispatch, id) => {
  dispatch({
    type: actions.BIBAVATARES_CACHE_ADMIN_UPDATE_REQUESTED,
    payload: id,
  })
}

export const onSubmitUpdateBibAvataresCacheFamiliasAction = dispatch => {
  dispatch({
    type: actions.BIBAVATARES_CACHE_FAMILIAS_UPDATE_REQUESTED,
  })
}

export const onSubmitUpdateBibAvataresCacheProductosAction = dispatch => {
  dispatch({
    type: actions.BIBAVATARES_CACHE_PRODUCTOS_UPDATE_REQUESTED,
  })
}

export const onSubmitUpdateBibAvataresCachePaisesAction = dispatch => {
  dispatch({
    type: actions.BIBAVATARES_CACHE_PAISES_UPDATE_REQUESTED,
  })
}

export const onSubmitUpdateBibAvataresCacheProvinciasAction = dispatch => {
  dispatch({
    type: actions.BIBAVATARES_CACHE_PROVINCIAS_UPDATE_REQUESTED,
  })
}

// Galeria > Carga masiva
export const onSubmitUploadBibAvataresGaleriaMasivo = (dispatch, formMasivo) => {
  dispatch({
    type: actions.BIBAVATARES_GALERIA_MASIVO_REQUESTED,
    payload: formMasivo,
  })
}

export const onSubmitConfirmBibAvataresGaleriaMasivo = (dispatch, formMasivo) => {
  dispatch({
    type: actions.BIBAVATARES_GALERIA_CONFIRM_MASIVO_REQUESTED,
    payload: formMasivo,
  })
}

// Galeria > Carga individual
export const onSubmitUploadBibAvataresGaleriaFile = (dispatch, form) => {
  dispatch({
    type: actions.BIBAVATARES_GALERIA_UPLOAD_IMAGE_REQUESTED,
    payload: form,
  })
}

// Plantillas
export const getBibAvataresPlantillasAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.BIBAVATARES_PLANTILLA_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.BIBAVATARES_PLANTILLA_LOAD_REQUESTED,
    })
  }
}

export const deleteBibAvataresPlantillaAction = (dispatch, id) => {
  dispatch({
    type: actions.DELETE_BIBAVATARES_PLANTILLA_REQUESTED,
    payload: id,
  })
}

export const onSubmitInsertBibAvataresPlantillaFormAction = (
  dispatch,
  formBibAvataresPlantilla,
) => {
  dispatch({
    type: actions.BIBAVATARES_PLANTILLA_INSERT_REQUESTED,
    payload: formBibAvataresPlantilla,
  })
}

export const onSubmitUpdateBibAvataresPlantillaFormAction = (
  dispatch,
  formBibAvataresPlantilla,
) => {
  dispatch({
    type: actions.BIBAVATARES_PLANTILLA_UPDATE_REQUESTED,
    payload: formBibAvataresPlantilla,
  })
}

// Plantillas personalizadas > Objeto
export const getBibAvataresPlantillaObjetosAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.BIBAVATARES_PLANTILLA_OBJETO_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.BIBAVATARES_PLANTILLA_OBJETOS_LOAD_REQUESTED,
    })
  }
}

// Avatares > Capas
export const getBibAvataresLayerAction = (dispatch, fam) => {
  dispatch({
    type: actions.BIBAVATARES_LAYER_LOAD_REQUESTED,
    payload: fam,
  })
}

export const getBibAvataresLayerByIdAction = (dispatch, id) => {
  dispatch({
    type: actions.BIBAVATARES_LAYER_BYID_LOAD_REQUESTED,
    payload: id,
  })
}

export const deleteBibAvataresLayerAction = (dispatch, id) => {
  dispatch({
    type: actions.DELETE_BIBAVATARES_LAYER_REQUESTED,
    payload: id,
  })
}

export const onSubmitInsertBibAvataresLayerFormAction = (dispatch, formBibAvataresLayer) => {
  dispatch({
    type: actions.BIBAVATARES_LAYER_INSERT_REQUESTED,
    payload: formBibAvataresLayer,
  })
}

export const onSubmitUpdateBibAvataresLayerFormAction = (dispatch, formBibAvataresLayer) => {
  dispatch({
    type: actions.BIBAVATARES_LAYER_UPDATE_REQUESTED,
    payload: formBibAvataresLayer,
  })
}

// Avatares > Colores
export const getBibAvataresColorAction = (dispatch, pal) => {
  dispatch({
    type: actions.BIBAVATARES_COLOR_LOAD_REQUESTED,
    payload: pal,
  })
}

export const deleteBibAvataresColorAction = (dispatch, id) => {
  dispatch({
    type: actions.DELETE_BIBAVATARES_COLOR_REQUESTED,
    payload: id,
  })
}

export const onSubmitInsertBibAvataresColorFormAction = (dispatch, formBibAvataresColor) => {
  dispatch({
    type: actions.BIBAVATARES_COLOR_INSERT_REQUESTED,
    payload: formBibAvataresColor,
  })
}

export const onSubmitUpdateBibAvataresColorFormAction = (dispatch, formBibAvataresColor) => {
  dispatch({
    type: actions.BIBAVATARES_COLOR_UPDATE_REQUESTED,
    payload: formBibAvataresColor,
  })
}

export const onSubmitUpdateBibAvataresColorOrdenAction = (dispatch, data) => {
  dispatch({
    type: actions.BIBAVATARES_COLOR_UPDATE_ORDER_REQUESTED,
    payload: data,
  })
}

// Avatares > Familias por producto
export const getBibAvataresByProdId = (dispatch, prd) => {
  dispatch({
    type: actions.BIBAVATARES_PROD_BYID_LOAD_REQUESTED,
    payload: prd,
  })
}

// Avatares > Piezas
export const getBibAvataresPiezasAction = (dispatch, fam) => {
  dispatch({
    type: actions.BIBAVATARES_PIEZA_LOAD_REQUESTED,
    payload: fam,
  })
}

export const getBibAvataresPiezaByIdAction = (dispatch, id) => {
  dispatch({
    type: actions.BIBAVATARES_PIEZA_BYID_LOAD_REQUESTED,
    payload: id,
  })
}

export const deleteBibAvataresPiezaAction = (dispatch, id) => {
  dispatch({
    type: actions.DELETE_BIBAVATARES_PIEZA_REQUESTED,
    payload: id,
  })
}

export const onSubmitInsertBibAvataresPiezaFormAction = (dispatch, formBibAvataresPieza) => {
  dispatch({
    type: actions.BIBAVATARES_PIEZA_INSERT_REQUESTED,
    payload: formBibAvataresPieza,
  })
}

export const onSubmitUpdateBibAvataresPiezaFormAction = (dispatch, formBibAvataresPieza) => {
  dispatch({
    type: actions.BIBAVATARES_PIEZA_UPDATE_REQUESTED,
    payload: formBibAvataresPieza,
  })
}
